import * as yup from 'yup';

const DEFAULT_MESSAGE = 'Campo obrigatório';

export const ReajusteEstoqueSchema = yup.object().shape({
    responsavel: yup.string().required(DEFAULT_MESSAGE).nullable(),
    
    prod_descricao: yup.string().required(DEFAULT_MESSAGE).nullable(),
    
    qtd_real: yup.number()
        .typeError('Deve ser um número')
        .min(0, 'Quantidade real deve ser maior ou igual a zero')
        .required(DEFAULT_MESSAGE)
        .nullable(),    
    
    ocorrencia: yup.string()
        .required(DEFAULT_MESSAGE)
        .nullable(),
});